module.exports = __webpack_public_path__ + "img/remove-user.c9fe2e6c.png";